import React from 'react'
import QuickLinks from 'components/shared/QuickLinks'

export default function TradingTools(props) {
  const { title, softwares } = props
  const linkList = []
  if (softwares) {
    softwares.map((software) => {
      linkList.push({
        href: '/software/[slug]/',
        as: `/software/${software.attributes.slug}`,
        linkText: ` ${software.attributes.name}`,
      })
      return linkList
    })
  }
  return softwares ? <QuickLinks title={title} linkList={linkList} /> : null
}
